import Stack from '@mui/material/Stack';
import { createFileRoute } from '@tanstack/react-router';
import { Referral } from '../features/referral';
import { createPageBackgroundSx } from '../styles/pageBackground.ts';

export const Route = createFileRoute('/referrals')({
  component: ReferralPage,
});

const referralsPageSx = createPageBackgroundSx();

function ReferralPage() {
  return (
    <Stack sx={referralsPageSx}>
      <Referral></Referral>
    </Stack>
  );
}
